import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Toggle mobile menu
  const handleClick = () => setMenuOpen(!menuOpen);
  const closeMobileMenu = () => setMenuOpen(false);

  // Add glass effect on scroll
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
  if (menuOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
  return () => (document.body.style.overflow = "auto");
}, [menuOpen]);


  return (
    <nav id="navbar" className={scrolled ? "scrolled" : ""}>
      <div className="nav-container">
        {/* Side Menu / Mobile Menu */}
        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <button className="close-btn" onClick={closeMobileMenu}>
            &times;
          </button>
          <ul>
            <li>
              <Link to="/" className="nav" onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/services" className="nav" onClick={closeMobileMenu}>
                About
              </Link>
            </li>
            <li>
              <Link
                to="/products"
                className="nav"
                onClick={closeMobileMenu}
              >
                Web Development Projects
              </Link>
            </li>
            <li>
              <Link
                to="/GraphicDesign"
                className="nav"
                onClick={closeMobileMenu}
              >
                Graphic Design
              </Link>
            </li>
            <li>
              <Link
                to="/IllustrationWork"
                className="nav"
                onClick={closeMobileMenu}
              >
                Illustration
              </Link>
            </li>
            <li>
              <Link
                to="/Contact"
                className="nav"
                onClick={closeMobileMenu}
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Mobile Header */}
        <div className="mobile-header">
          <div className="menu-toggle" onClick={handleClick}>
            {menuOpen ? "✖" : "☰"}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
